import {createApp} from 'vue'
import DeletePostOverlay from './DeletePostOverlay'

const el = '[data-content=DeletePostOverlay]'

export default function (Store) { 
    // nothing to run 
}